"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const colors = {
    aliceBlue: '#F1F7FF',
    antiFlash: '#EFF1F5',
    antiFlashWhite: '#ebf8f2',
    azureish: '#DFE3EC',
    azureishWhite: '#DAE8F0',
    black: '#000000',
    blackCoral: '#606672',
    cadetGrey: '#9BA5B1',
    cinnabar: '#E63A1A',
    columbiaBlue: '#D0D5E2',
    coolGrey: '#8D94A6',
    cornflowerBlue: '#538DE3',
    cosmicLatte: '#fff9e9',
    crayola: '#FD504F',
    cultured: '#F4F5F7',
    darkModerateBlue: '#4267B2',
    dodgerBlue: '#0068FF',
    gold: '#FFC200',
    lightPeriwinkle: '#C0C7D9',
    linkWater1: '#CFD1D6',
    linkWater2: '#D1D5DB',
    lotion: '#FBFBFC',
    mediumSeaGreen: '#36B37E',
    melon: '#FFBFB3',
    midnightBlue: '#0C1A33',
    orangeRed: '#FF2800',
    pastelBlue: '#B1BAD0',
    rhino: '#3D485C',
    richBlack: '#030F27',
    seashell: '#FFF1EE',
    shuttleGrey: '#585F68',
    solitude1: '#E5E7E9',
    solitude2: '#E7E9EC',
    trout: '#474E52',
    vividBlue: '#1DA1F2',
    wewak: '#FF9799',
    whatsapp: '#43CD66',
    whatsappDisabled: '#9BDFA9',
    whatsappText: '#103929',
    whisper: '#ECECEC',
    white: '#FFFFFF'
};
const theme = {
    palette: {
        primary: colors.orangeRed,
        secondary: colors.midnightBlue,
        error: colors.wewak,
        warning: '',
        info: colors.dodgerBlue,
        success: colors.mediumSeaGreen,
        text: {
            primary: colors.midnightBlue,
            secondary: colors.white,
            disabled: colors.lightPeriwinkle
        },
        colors: {
            ...colors
        }
    },
    typography: {
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeightMedium: 500,
        fontWeightSemiBold: 600,
        fontFamily: 'Lexend',
        fontSize: {
            small: '12px',
            medium: '14px',
            large: '16px'
        }
    },
    grid: {
        container: {
            xs: 'full',
            sm: 'full',
            md: 'full',
            lg: 'full',
            xl: 102.8571429
        },
        padding: {
            xs: 2.125,
            sm: 2.125,
            md: 4.357142879,
            lg: 6.535714318,
            xl: 8.714285757
        },
        columns: {
            xs: 4,
            sm: 4,
            md: 4,
            lg: 12,
            xl: 12
        },
        gutter: {
            xs: 2.125,
            sm: 2.125,
            md: 2.61444805,
            lg: 2.125,
            xl: 3.1038961
        },
        breakpoints: {
            xs: 1,
            sm: 33.75,
            md: 48,
            lg: 64,
            xl: 71.25
        },
        colors: {
            blue: '#0470F5'
        }
    }
};
exports.default = theme;
//# sourceMappingURL=defaultTheme.js.map